

export const packagingMixin = {



}